// @Vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Websocket from 'react-websocket';

// @Components
import Table from '../../components/tableSimple';

class Checkinout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checks: []
    }
  }

  handleData(data) {
    let result = JSON.parse(data);
    console.log(data);
    const s = this.state.checks.slice();
    s.splice(0, 0, result);
    this.setState({checks: s})
  }

  getColumns = () => [
    {
      id: 'fecha',
      numeric: false,
      disablePadding: false,
      label: 'Fecha/hora',
      render: (value, row) => moment(row.gateCheckInOut === 'I' ? row.gateLugarUsuarioEntradaR : row.gateLugarUsuarioSalidaR).format('DD/MM/YYYY HH:mm:ss')
    },
    {
      numeric: false,
      disablePadding: true,
      label: 'Fecha/hora programada',
      render: (value, row) => {
        if (row.gateCheckInOut === 'I') return row.gateLugarUsuarioEntradaP ? moment(row.gateLugarUsuarioEntradaP).format('DD/MM/YYYY HH:mm:ss') : 'Sin datos';
        else return row.gateLugarUsuarioSalidaP ? moment(row.gateLugarUsuarioSalidaP).format('DD/MM/YYYY HH:mm:ss') : 'Sin datos';
      }
    },
    {
      id: 'usuarioApellidoYNombre',
      numeric: false,
      disablePadding: true,
      label: 'Apellido y Nombre',
    },
    {
      id: 'tipoDeDocumentoCod',
      numeric: false,
      disablePadding: false,
      label: 'Tipo de documento'
    },
    {
      id: 'usuarioNroDeDocumento',
      numeric: false,
      disablePadding: false,
      label: 'Nro de documento'
    },
    {
      id: 'gateCheckInOut',
      numeric: false,
      disablePadding: true,
      label: 'Entrada/Salida',
      render: value => value === 'I' ? 'Entrada' : 'Salida'
    },
    {
      id: 'gateLugarNombre',
      numeric: false,
      disablePadding: true,
      label: 'Lugar',
    },
    {
      numeric: false,
      disablePadding: true,
      label: 'Posicion',
      render: (value, row) => `${row.geoLatitud},${row.geoLongitud}`
    }
  ];

  render() {
    // const {
    //   filters,
    //   isLoading,
    //   updateFilters,
    //   users,
    // } = this.props;

    // const {
    //   order,
    //   orderBy,
    //   page,
    //   rowsPerPage,
    //   selected,
    // } = filters;
    return (
      <div className='row'>
        <div id='top_body'>
          <h1 className='big'>Check-in / Check-out</h1>

        </div>
        <div id='content_body_list'>

          <div className='onboarding_list'>
            <Table
              isLoading={false}
              fieldId="usuarioId"
              columns={this.getColumns()}
              // order={order}
              // orderBy={orderBy}
              // page={page}
              // requestSort={(order, orderBy) => {
              //   updateFilters({ ...filters, order, orderBy })
              // }}
              rows={this.state.checks}
              rowsPerPage={100}
              selected={[]}
              // setPage={(page) => {
              //   updateFilters({ ...filters, page })
              //}}
              // setRowsPerPage={(rowsPerPage) => {
              //   updateFilters({ ...filters, rowsPerPage })
              // }}
              // setSelected={selected => {
              //   updateFilters({ ...filters, selected })
              // }}
            />
          </div>
        </div>
        <Websocket url={process.env.REACT_APP_WEBSOCKET_URL} onMessage={this.handleData.bind(this)}/>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  // filters: selectFilters(state),
  // isLoading: selectIsLoading(state),
  // registers: selectRegisters(state),
  // users: selectUsers(state),
});

const actions = {
  // getUserRegisters,
  // getUserStatus,
  // getUsers,
  // updateFilters,
};

export default connect(
  mapStateToProps,
  actions
)(Checkinout);



// WEBPACK FOOTER //
// ./src/pages/Checkinout/index.js